<div class="camera-details">
  <div class="camera-table-details-container-fluid">
    <div class="camera-table-details-row">
      <div *ngIf="camera.make !== 'LVT'" class="camera-table-details-col-3 camera-col">
        <sn-audit-camera-stream-view
          *ngIf="hasUrls"
          #auditCameraStream
          [autoplay]="true"
          [camera]="selectedCamera"
          [controls]="true"
        >
        </sn-audit-camera-stream-view>
      </div>
      <div *ngIf="camera.make === 'LVT'" class="camera-table-details-col-3 camera-col">
        <fs-lvt-feed-card [lvt]="camera" (removeLvt)="removeLvt($event)"></fs-lvt-feed-card>
      </div>
      <div class="camera-table-details-col-3">
        <fs-map
          *ngIf="camera.geometry"
          zoom="19"
          [center]="camera.geometry.coordinates"
          (mapInit)="onMapInit($event)"
        ></fs-map>
      </div>
      <div class="camera-table-details-col-3">
        <mat-list>
          <mat-list-item>
            <div matLine>{{ camera?.disposition }}</div>
            <div matLine class="fs-text-secondary">{{ 'common.disposition' | t }}</div>
          </mat-list-item>
          <mat-list-item *ngIf="camera?.model && camera?.make">
            <div matLine>{{ camera?.model }} / {{ camera?.make }}</div>
            <div matLine class="fs-text-secondary">{{ 'cameras.details.labels.modelMake' | t }}</div>
          </mat-list-item>
          <mat-list-item>
            <div matLine>{{ camera?.type }}</div>
            <div matLine class="fs-text-secondary">{{ 'common.control' | t }}</div>
          </mat-list-item>
        </mat-list>
      </div>
      <div class="camera-table-details-col-3">
        <mat-list>
          <mat-list-item class="tag-list" *ngIf="camera.tags.length || camera.canEdit">
            <sn-icon matListIcon>local_offer</sn-icon>
            <sn-tag-edit-list
              matLine
              [contentType]="'common.camera' | t"
              [tags]="camera.tags"
              [canChange]="camera.canEdit"
              (tagsChanged)="onTagsChanged($event)"
            >
            </sn-tag-edit-list>
          </mat-list-item>
        </mat-list>
      </div>
    </div>
    <div class="camera-table-details-row">
      <div
        class="camera-table-details-col-11 childCamsWrapper"
        [class.hideList]="
          (!list?.dataSource?.data?.length && list?.dataIsInited) || !camera.isParentCamera
        "
      >
        <div class="childCamsHeader">
          <h5 style="color: #ffca28">{{ 'cameras.details.labels.descendantCameras' | t }}</h5>
          <div class="childCamActions">
            <sn-icon-button
              color="accent"
              *ngIf="camera?.id !== selectedCamera?.id"
              [matTooltip]="'cameras.details.tooltips.returnToParentCamera' | t"
              class="descendantActionButtons"
              (click)="goToParent()"
            >
              <sn-icon fontSet="fal" fontIcon="fa-camera-rotate"></sn-icon>
            </sn-icon-button>
            <sn-icon-button
              color="accent"
              [matTooltip]="'cameras.details.tooltips.addDescendant' | t"
              class="descendantActionButtons"
              (click)="add.next(this.camera)"
            >
              <sn-icon fontSet="fal" fontIcon="fa-plus"></sn-icon>
            </sn-icon-button>
            <sn-icon-button
              color="accent"
              [matTooltip]="'common.reload' | t"
              class="descendantActionButtons"
              (click)="reloadData()"
            >
              <sn-icon fontSet="fal" fontIcon="fa-redo-alt"></sn-icon>
            </sn-icon-button>
          </div>
        </div>
        <sn-data-list #listElement [fetchFn]="loadData">
          <sn-infinite-scroll class="childCameraList">
            <sn-pull-to-refresh>
              <ng-template [ngIf]="list?.dataSource?.data?.length" [ngIfThen]="table"></ng-template>
              <ng-template
                [ngIf]="!list?.dataSource?.data?.length && list?.dataIsInited"
                [ngIfThen]="emptyList"
              ></ng-template>
            </sn-pull-to-refresh>
          </sn-infinite-scroll>

          <ng-template #table>
            <sn-camera-table
              [columns]="columns"
              [items]="list?.dataSource?.data"
              [actions]="actions"
              [isExpandable]="false"
              (selectedCam)="onSelectedCam($event)"
            ></sn-camera-table>
          </ng-template>

          <ng-template #emptyList>
            <sn-empty-state icon="cancel_presentation" [title]="'common.noResults' | t">
              {{ 'common.noResultsMatchSearch' | t }}
            </sn-empty-state>
          </ng-template>
        </sn-data-list>
      </div>
    </div>
  </div>
</div>
